/* ============================================================================
   cl-pdp-pakket.js — de pakketkiezer (Cecile Lavelle)

   Doet precies twee dingen:
   1. de gekozen trede zet het AANTAL in het bestelformulier
   2. bij een andere variant worden de bedragen opnieuw gerekend

   Meer niet. De korting zelf komt van een automatische korting in Shopify;
   dit blok belooft dus niets wat de kassa niet geeft. Zolang die korting er
   niet is klopt de rekensom nog steeds — er staat dan alleen geen voordeel.

   De bedragen worden hier opnieuw opgebouwd omdat de prijs per variant kan
   verschillen. De opmaak van het bedrag komt uit het formaat dat liquid heeft
   meegegeven, zodat er geen tweede geldnotatie in de winkel ontstaat.
   ============================================================================ */
(function () {
  'use strict';

  function centen(el) {
    return parseInt(el.getAttribute('data-basis'), 10) || 0;
  }

  // Het geldformaat komt uit de winkel en niet uit dit bestand: liquid heeft de
  // eerste prijs al opgemaakt, dus daaruit is af te leiden waar het teken staat,
  // welk scheidingsteken erbij hoort en of er cijfers achter de komma komen.
  function opmaker(voorbeeld) {
    var m = voorbeeld.match(/(\d[\d.,\s]*\d|\d)/);
    if (!m) return function (c) { return (c / 100).toFixed(2); };
    var getal = m[1];
    var voor = voorbeeld.slice(0, m.index);
    var na = voorbeeld.slice(m.index + getal.length);
    var komma = getal.indexOf(',') > getal.indexOf('.') ? ',' : '.';
    var duizend = komma === ',' ? '.' : ',';
    var decimalen = (getal.split(komma)[1] || '').length;

    return function (c) {
      var v = (c / 100).toFixed(decimalen);
      var delen = v.split('.');
      delen[0] = delen[0].replace(/\B(?=(\d{3})+(?!\d))/g, duizend);
      return voor + delen.join(komma) + na;
    };
  }

  function ververs(blok) {
    var basis = centen(blok);
    if (!basis) return;

    var eerste = blok.querySelector('[data-cl-pakprijs]');
    if (!eerste) return;
    var maak = opmaker(eerste.textContent.trim());

    var treden = blok.querySelectorAll('[data-cl-trede]');
    for (var i = 0; i < treden.length; i++) {
      var trede = treden[i];
      var aantal = parseInt(trede.getAttribute('data-cl-trede'), 10);
      var pct = parseFloat(trede.getAttribute('data-cl-korting')) || 0;

      // Per stuk en naar beneden, net als Shopify: 49,95 × 10 % = 4,995 wordt
      // 4,99 per stuk en dus 9,98 over twee stuks. Rond je over de regel af,
      // dan staat hier 9,99 en geeft de kassa 9,98. Zie ook de gelijke som in
      // snippets/cl-pdp-pakket.liquid — die twee moeten hetzelfde doen.
      var vol = basis * aantal;
      var af = Math.floor((basis * pct) / 100) * aantal;
      var nu = vol - af;

      var prijs = trede.querySelector('[data-cl-pakprijs]');
      if (prijs) {
        prijs.innerHTML = maak(nu) + (pct > 0 ? '<s>' + maak(vol) + '</s>' : '');
      }
      var besparing = trede.querySelector('[data-cl-besparing]');
      if (besparing && besparing.getAttribute('data-vorm')) {
        besparing.textContent = besparing.getAttribute('data-vorm')
          .replace('#PCT#', pct)
          .replace('#AMT#', maak(af));
      }
    }
  }

  /* ── De keuze per stuk ──────────────────────────────────────────
     Elke rij heeft een lijst per optie — in deze winkel altijd kleur en maat.
     De eerste lijst toont alle kleuren die er zijn; de tweede vult zich met de
     maten die in díe kleur bestaan en op voorraad zijn. Zo is alles wat bestaat
     te kiezen, en niets wat niet bestaat.

     De rij onthoudt zijn eigen keuze op `data-variant`. Zolang niemand hem heeft
     aangeraakt loopt hij mee met de variant die bovenaan gekozen is; daarna
     blijft hij staan. Wie de kleur bovenaan wisselt bedoelt meestal het hele
     pakket; wie een stuk expliciet op iets anders zette, bedoelt dát. */
  function gegevens(blok) {
    var doos = blok.querySelector('[data-cl-pakextra]');
    if (!doos) return null;
    if (!doos._data) {
      try {
        doos._data = {
          varianten: JSON.parse(doos.getAttribute('data-cl-varianten') || '[]'),
          etiketten: JSON.parse(doos.getAttribute('data-cl-etiketten') || '{}'),
        };
      } catch (e) { return null; }
    }
    return doos._data;
  }

  function etiket(d, index, waarde) {
    var per = d.etiketten[String(index)];
    return (per && per[waarde]) || waarde;
  }

  // De waarden die op plek `index` nog kunnen, gegeven wat er links van staat.
  function kanNog(d, index, keuze) {
    var uit = [];
    for (var i = 0; i < d.varianten.length; i++) {
      var v = d.varianten[i];
      var past = true;
      for (var j = 0; j < index; j++) {
        if (keuze[j] && v.o[j] !== keuze[j]) { past = false; break; }
      }
      if (past && uit.indexOf(v.o[index]) === -1) uit.push(v.o[index]);
    }
    return uit;
  }

  function zoekVariant(d, keuze) {
    for (var i = 0; i < d.varianten.length; i++) {
      var v = d.varianten[i], past = true;
      for (var j = 0; j < keuze.length; j++) if (v.o[j] !== keuze[j]) { past = false; break; }
      if (past) return v;
    }
    return null;
  }

  function keuzeVanRij(rij) {
    var lijsten = rij.querySelectorAll('[data-cl-optie]');
    var keuze = [];
    for (var i = 0; i < lijsten.length; i++) keuze.push(lijsten[i].value);
    return keuze;
  }

  // Vult de lijsten van één rij en zet er de variant bij die eruit volgt.
  // `voorkeur` is een variant-id waar de rij naartoe moet als dat kan.
  function vulRij(blok, rij, voorkeur) {
    var d = gegevens(blok);
    if (!d || !d.varianten.length) return;
    var lijsten = rij.querySelectorAll('[data-cl-optie]');
    var wens = null;
    if (voorkeur) {
      for (var i = 0; i < d.varianten.length; i++) if (String(d.varianten[i].i) === String(voorkeur)) wens = d.varianten[i];
    }
    var huidig = keuzeVanRij(rij);
    var keuze = [];

    for (var k = 0; k < lijsten.length; k++) {
      var mogelijk = kanNog(d, k, keuze);
      var wil = wens ? wens.o[k] : huidig[k];
      if (mogelijk.indexOf(wil) === -1) wil = mogelijk[0];
      keuze.push(wil);

      // Alleen opnieuw opbouwen als de inhoud echt verandert; anders klapt een
      // open lijst dicht bij elke wissel elders op de pagina.
      var nu = [];
      for (var o = 0; o < lijsten[k].options.length; o++) nu.push(lijsten[k].options[o].value);
      if (JSON.stringify(nu) !== JSON.stringify(mogelijk)) {
        lijsten[k].innerHTML = '';
        for (var m = 0; m < mogelijk.length; m++) {
          var opt = document.createElement('option');
          opt.value = mogelijk[m];
          opt.textContent = etiket(d, k, mogelijk[m]);
          lijsten[k].appendChild(opt);
        }
      }
      lijsten[k].value = wil;
    }

    var v = zoekVariant(d, keuze);
    if (v) rij.setAttribute('data-variant', v.i);
  }

  function vulAlleRijen(blok, voorkeur) {
    var rijen = blok.querySelectorAll('[data-cl-pakrij]');
    for (var i = 0; i < rijen.length; i++) vulRij(blok, rijen[i], voorkeur);
  }

  // Wissel je de kleur bovenaan, dan verandert alléén stuk 1 mee. Stuk 2 en 3
  // blijven staan waar ze staan.
  //
  // Eerst liepen ze mee zolang je ze niet had aangeraakt. Dat leek logisch — wie
  // de kleur bovenaan wisselt bedoelt vaak het hele pakket — maar het werkt
  // averechts: het hele aanbod is "neem 'm in twee kleuren", en dan is het
  // irritant dat je tweede keuze wegspringt zodra je aan de eerste komt. Stuk 1
  // ís de variant van de pagina en moet dus wél volgen.
  function volgAlleenStukEen(blok, variantId) {
    var rij = blok.querySelector('[data-cl-pakrij="1"]');
    if (rij) vulRij(blok, rij, variantId);
  }

  function toonExtra(blok, aantal) {
    var doos = blok.querySelector('[data-cl-pakextra]');
    if (!doos) return;
    doos.hidden = aantal < 2;
    var rijen = blok.querySelectorAll('[data-cl-pakrij]');
    for (var i = 0; i < rijen.length; i++) {
      var n = parseInt(rijen[i].getAttribute('data-cl-pakrij'), 10);
      rijen[i].hidden = n > aantal;
    }
    // De doos verhuist naar de gekozen trede in plaats van dat elke trede een
    // eigen stel lijsten krijgt. Zo blijft een gemaakte keuze staan als je van
    // twee naar drie stuks gaat — met drie losse stellen zou hij weg zijn.
    var vak = blok.querySelector('[data-cl-tredevak="' + aantal + '"]');
    if (vak && doos.parentElement !== vak) vak.appendChild(doos);
  }

  // Stuk 1 ís de variant die de pagina toont. Wie hem daar wisselt, wisselt de
  // hele pagina: prijs, foto's en de stalen bovenaan.
  //
  // Dat gaat via de optievelden (#option1, #option2) en niet via het verborgen
  // veld [name="id"]. Dat laatste was de eerste opzet en werkte niet: het thema
  // luistert op de optievelden en niet op het id-veld, dus de pagina bleef op de
  // oude variant staan. Gemeten: scherm zei Schwarz, mandje kreeg Rot.
  // Dezelfde haak gebruikt assets/cl-pdp-sticky.js voor de keuze in de balk.
  function stuurHoofdvariant(blok, variantId) {
    var d = gegevens(blok);
    if (!d || !variantId) return;
    var v = null;
    for (var i = 0; i < d.varianten.length; i++) {
      if (String(d.varianten[i].i) === String(variantId)) { v = d.varianten[i]; break; }
    }
    if (!v) return;
    for (var k = 0; k < v.o.length; k++) {
      var veld = document.querySelector('.product__details #option' + (k + 1)) || document.querySelector('#option' + (k + 1));
      if (!veld || veld.value === v.o[k]) continue;
      veld.value = v.o[k];
      veld.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function kies(blok, trede) {
    var gekozen = parseInt(trede.getAttribute('data-cl-trede'), 10) || 1;
    var vakken = blok.querySelectorAll('[data-cl-tredevak]');
    for (var i = 0; i < vakken.length; i++) {
      vakken[i].classList.toggle(
        'cl-pdp__paktrede--aan',
        parseInt(vakken[i].getAttribute('data-cl-tredevak'), 10) === gekozen
      );
    }
    toonExtra(blok, gekozen);

    // Het aantal in het bestelformulier. Dat is de hele koppeling: de korting
    // regelt Shopify, niet deze pagina.
    var aantal = trede.getAttribute('data-cl-trede');

    // En het bedrag in de koopknop, zodat daar staat wat je werkelijk afrekent.
    // De opmaak komt uit de prijs die op de gekozen trede staat — dus uit het
    // geldformaat van de winkel, niet uit dit bestand.
    var knop = document.querySelector('[data-cl-knopprijs]');
    var opTrede = trede.querySelector('[data-cl-pakprijs]');
    if (knop && opTrede) {
      knop.textContent = (opTrede.childNodes[0] && opTrede.childNodes[0].textContent || '').trim();
    }
    var veld = document.querySelector('.product__details [name="quantity"], form[action*="/cart/add"] [name="quantity"]');
    if (veld) {
      veld.value = aantal;
      veld.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var trede = e.target.closest('[data-cl-trede]');
    if (!trede) return;
    var blok = trede.closest('[data-cl-pakket]');
    if (blok) kies(blok, trede);
  });

  document.addEventListener('change', function (e) {
    var lijst = e.target.closest && e.target.closest('[data-cl-optie]');
    if (!lijst) return;
    var rij = lijst.closest('[data-cl-pakrij]');
    var blok = lijst.closest('[data-cl-pakket]');
    if (!rij || !blok) return;
    rij.setAttribute('data-aangeraakt', '1');
    // Opnieuw vullen zonder voorkeur: de kolommen rechts van de gewijzigde
    // moeten meebewegen (een andere kleur heeft andere maten).
    vulRij(blok, rij, null);
    if (rij.getAttribute('data-cl-pakrij') === '1') stuurHoofdvariant(blok, rij.getAttribute('data-variant'));
  }, true);

  /* ── Toevoegen als de stukken van elkaar verschillen ───────────────────────
     Staat alles op dezelfde variant, dan verandert er niets: het formulier gaat
     gewoon met aantal N naar de winkel, precies zoals het altijd deed, inclusief
     de laadstaat van de knop en het openen van de lade door het thema.

     Verschilt er iets, dan moeten er meerdere regels in het mandje. Dan gaan
     eerst de afwijkende stukken erin via /cart/add.js, en daarna laten we het
     formulier zijn eigen gang gaan voor de rest. Zo doet het thema het openen en
     verversen van de lade, en is er geen herlaadbeurt nodig.

     Waarom niet álles via /cart/add.js: dan moeten wij de lade openen, en dat
     kan Stiletto alleen na een herlaadbeurt (zie assets/cl-qa.js). De koopknop
     trager maken voor iedereen is een te hoge prijs voor één code-pad. */
  var bezig = false;

  function verzamel(blok) {
    var vak = blok.querySelector('.cl-pdp__paktrede--aan');
    var aantal = vak ? parseInt(vak.getAttribute('data-cl-tredevak'), 10) : 1;
    if (!aantal || aantal < 2) return null;

    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;

    // Alles komt uit de zichtbare keuzerijen — wat op het scherm staat is wat er
    // in het mandje hoort te komen. De variant die op dat moment in het
    // formulier staat doet er niet toe.
    //
    // Dat was de fout: eerder werd die formulier-variant als "hoofdstuk"
    // genomen, en stond er iets anders in de rijen, dan viel de telling terug
    // op één stuk van de óude variant. Gemeten: scherm zei Schwarz + Blau, mandje
    // kreeg Rot + Blau.
    var stukken = [];
    var rijen = blok.querySelectorAll('[data-cl-pakrij]');
    for (var i = 0; i < rijen.length; i++) {
      var n = parseInt(rijen[i].getAttribute('data-cl-pakrij'), 10);
      var id = rijen[i].getAttribute('data-variant');
      if (n <= aantal && id) stukken.push(String(id));
    }
    if (stukken.length !== aantal) return null;

    // Tellen per variant, zodat twee keer dezelfde keuze één regel met aantal 2
    // wordt en niet twee regels van één.
    var telling = {};
    stukken.forEach(function (v) { telling[v] = (telling[v] || 0) + 1; });

    // Eén variant gaat via het formulier zodat het thema de lade opent; de rest
    // gaat er los in. Welke dat is maakt niet uit — stuk 1 ligt voor de hand.
    var hoofd = stukken[0];
    var veldId = form.querySelector('[name="id"]');
    var anders = Object.keys(telling).length > 1 || (veldId && String(veldId.value) !== hoofd);
    if (!anders) return null;

    return { hoofd: hoofd, telling: telling, form: form };
  }

  document.addEventListener('submit', function (e) {
    if (bezig) return;
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1) return;
    var blok = document.querySelector('[data-cl-pakket]');
    if (!blok) return;

    var plan = verzamel(blok);
    if (!plan) return;   // alles gelijk → het thema doet het zelf

    // stopPropagation en niet alleen preventDefault: Stiletto luistert zelf ook
    // op `submit` en legt het artikel via zijn eigen Ajax in het mandje.
    // preventDefault houdt alleen de bláding tegen, niet die luisteraar — gemeten
    // gingen er dan drie verzoeken uit en lag er één stuk te veel in het mandje.
    // Deze luisteraar staat in de capture-fase, dus hier stoppen betekent dat het
    // thema hem nooit ziet. Bij het opnieuw indienen hieronder is `bezig` waar en
    // stoppen we niets, zodat het thema dan wél zijn werk doet.
    e.preventDefault();
    e.stopPropagation();

    var extra = [];
    Object.keys(plan.telling).forEach(function (id) {
      if (id !== plan.hoofd) extra.push({ id: Number(id), quantity: plan.telling[id] });
    });

    var wortel = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(wortel.replace(/\/*$/, '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: extra }),
    })
      .then(function (r) { if (!r.ok) throw new Error('mislukt'); return r.json(); })
      .then(function () {
        // De rest is het hoofdstuk zelf; dat gaat via het formulier, zodat het
        // thema de lade opent en bijwerkt.
        // Het id-veld hier expliciet zetten en niet hopen dat het thema het al
        // goed heeft: bij het indienen telt alleen wat er in het veld staat.
        var veldId = plan.form.querySelector('[name="id"]');
        if (veldId) veldId.value = plan.hoofd;
        var veld = plan.form.querySelector('[name="quantity"]');
        if (veld) veld.value = plan.telling[plan.hoofd];
        bezig = true;
        if (plan.form.requestSubmit) plan.form.requestSubmit();
        else plan.form.submit();
        setTimeout(function () { bezig = false; }, 3000);
      })
      .catch(function () {
        // Niets stils: laat het formulier alsnog zijn werk doen, dan komt in elk
        // geval het hoofdstuk in het mandje en ziet de bezoeker wat er gebeurde.
        bezig = true;
        if (plan.form.requestSubmit) plan.form.requestSubmit();
        else plan.form.submit();
        setTimeout(function () { bezig = false; }, 3000);
      });
  }, true);

  // Bij een andere maat of kleur kan de prijs verschillen. De gekozen variant
  // staat in het verborgen veld dat het thema bijwerkt; de prijzen staan als
  // lijst op het blok. Zo is er één bron en wordt er geen opgemaakt bedrag van
  // het scherm teruggerekend.
  function volgVariant(blok) {
    var prijzen;
    try { prijzen = JSON.parse(blok.getAttribute('data-prijzen') || '{}'); }
    catch (e) { return; }

    // De derde parameter is `true`: luisteren in de capture-fase.
    //
    // Dat is geen voorkeur maar noodzaak. Stiletto vuurt bij een variantwissel
    // een `change` af met `bubbles: false` — gemeten: één op de verborgen select
    // en één op het formulier zelf, allebei niet-bubbelend. Een gewone
    // luisteraar op `document` ziet die dus nooit. Zonder capture stond deze
    // functie hier al die tijd voor niets: de tredeprijzen werden bij een
    // andere kleur of maat nooit herrekend. Dat viel niet op omdat de varianten
    // van één product hier bijna altijd dezelfde prijs hebben.
    document.addEventListener('change', function (e) {
      var form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      var id = form.querySelector('[name="id"]');
      if (!id || !prijzen[id.value]) return;
      blok.setAttribute('data-basis', prijzen[id.value]);
      ververs(blok);
      volgAlleenStukEen(blok, id.value);
    }, true);
  }

  function start() {
    var blok = document.querySelector('[data-cl-pakket]');
    if (!blok) return;
    ververs(blok);
    var doos = blok.querySelector('[data-cl-pakextra]');
    vulAlleRijen(blok, doos && doos.getAttribute('data-cl-start'));
    volgVariant(blok);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
